import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import NotificationPanel from '../components/NotificationPanel';
import PayrollUploader from '../components/PayrollUploader';

const BulletinDePaie: React.FC = () => {
  const [isNotifPanelOpen, setIsNotifPanelOpen] = useState(false);

  return (
    <div className={`flex min-h-screen bg-base-200 ${isNotifPanelOpen ? 'overflow-hidden' : ''}`}>
      <Sidebar />
      <main className="flex-1 p-6 overflow-y-auto">
        <Navbar onOpenNotifPanel={() => setIsNotifPanelOpen(true)} />

        {/* Nouvel en-tête */}
        <div className="flex flex-col gap-6 mb-6">
          <div className="flex justify-between items-center">
            <h2 className="text-3xl font-extrabold text-base-content">Bulletin de paie</h2>
            <div className="text-sm text-base-content/70">
              {/* Vous pouvez ajouter un compteur ou autre information ici si nécessaire */}
            </div>
          </div>
        </div>

        {/* Uploader + Historique */}
        <PayrollUploader showHeader={false} />
      </main>

      <NotificationPanel isOpen={isNotifPanelOpen} onClose={() => setIsNotifPanelOpen(false)} />
    </div>
  );
};

export default BulletinDePaie;